import { CSSProperties, FC, useEffect, useState } from 'react';
import { Color, Colors } from '../Colors';

import cn from 'clsx';

import './Card.css';

export type CardProps = {
  title?: string;
  type?: 'default' | 'random';
  color?: Color | string;
  bgColor?: Color | string;
  borderColor?: Color | string;
  shadowColor?: Color | string;
  style?: CSSProperties;
  accessory?: JSX.Element;
  className?: string;
  neon?: string;
};

const Card: FC<CardProps> = ({
  title,
  type,
  color = 'white',
  bgColor = 'blue',
  shadowColor = 'salmon',
  borderColor,
  accessory,
  children,
  className,
  style,
  neon = '',
}) => {
  if (Colors[color]) color = Colors[color];
  if (Colors[bgColor]) bgColor = Colors[bgColor];
  if (Colors[shadowColor]) shadowColor = Colors[shadowColor];

  const [shadowC, setShadowColor] = useState(shadowColor);
  useEffect(() => {
    if (type === 'random') {
      const colors = Object.keys(Colors);
      // pick random
      const color = Colors[colors[(colors.length * Math.random()) << 0]];
      setShadowColor(color);
    }
  }, [type]);

  return (
    <div
      className={cn('card w-full', className)}
      style={
        !!neon
          ? {
              backgroundColor: 'transparent',
              border: `solid 2px transparent`,
              color: '#2EFFE4',
              borderRadius: '0',
              ...style,
            }
          : {
              color,
              backgroundColor: bgColor,
              borderColor:
                title || borderColor ? borderColor || shadowC : 'transparent',
              boxShadow: `6px 7px 0px 0px ${shadowC}`,
              ...style,
            }
      }
    >
      {(title || accessory) && (
        <div className="card-header w-full">
          {title && (
            <div>
              <p
                className="font-bold tracking-normal px-6 py-3 -ml-px -mt-px select-none"
                style={{ backgroundColor: shadowC }}
              >
                {title}
              </p>
            </div>
          )}
          {accessory && (
            <div className="card-header-accessory w-full">{accessory}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
